import { useApi } from '@/features/api/useAPI'
import { useTelemetry } from '@/features/telemetry/useTelemetry'

export async function getUpliftsSum(): Promise<number | undefined | null> {
	const { trackException } = useTelemetry()
	const { apiGet } = useApi()

	try {
		const { data } = await apiGet<number | null>('/events/upliftsSum')

		return data
	} catch (e) {
		trackException(e as Error, 'Failed to load uplift sum.')
	}
}
